import type { Props } from './index';

export type HighlightTextProps = {
	selected: boolean;
};

export type HighlightTextState = {
	useAccentStyles: boolean;
};

export function isHighlightTextState(props: Props): props is HighlightTextProps {
	return !!(props && 'selected' in props);
}

export function highlightTextState(
	selected: boolean,
	variant: string | undefined,
	enabled: boolean,
): HighlightTextState {
	return { useAccentStyles: selected || (enabled && variant !== 'control') };
}
